<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para1"><a id="page_i"></a>P<span class="smallcaps">RAISE FOR</span> W<span class="smallcaps">ALTER</span> J. B<span class="smallcaps">OYNE</span></p>
<p class="para">“The saga isn’t a new genre, but the aviation saga is—and Walter Boyne invented it. Here’s a first-rate story of the jet age from our foremost aviation writer.”</p>
<p class="right-para">—Stephen Coonts on <em>Supersonic Thunder</em></p>
<p class="para">“Boyne packs the novel with historically accurate detail. Aviation fans will gulp this one down in one long, satisfied swallow.”</p>
<p class="right-para">—<em>Booklist</em> on <em>Roaring Thunder</em></p>
<p class="para">“Boyne’s narrative follows the story until 1954, incorporating the evolution of the B-52 bomber and the Boeing 707 commercial jet airliner. . . . Boyne doesn’t disappoint.”</p>
<p class="right-para">—<em>Publishers Weekly</em> on <em>Roaring Thunder</em></p>
<p class="para">“<em>Dawn Over Kitty Hawk</em> is an amazing book. Not only is it riveting history, it is also a suspense story that takes readers inside the ferocious competition to be the first in flight.”</p>
<p class="right-para">—Thomas Fleming, president of the Society of<br/>American Historians and <em>New York Times</em> bestselling<br/>author of <em>The Secret Trial of Robert E. Lee</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?5b215928